import {
  FETCH_USERLOGIN_REQUEST,
  FETCH_USERLOGIN_SUCCESS,
  FETCH_USERLOGIN_FAILURE,
  CREATE_USERLOGIN_REQUEST,
  CREATE_USERLOGIN_SUCCESS,
  CREATE_USERLOGIN_FAILURE,
  UPDATE_USERLOGIN_REQUEST,
  UPDATE_USERLOGIN_SUCCESS,
  UPDATE_USERLOGIN_FAILURE,
  DELETE_USERLOGIN_REQUEST,
  DELETE_USERLOGIN_SUCCESS,
  DELETE_USERLOGIN_FAILURE,
} from "./userActionTypes";
export const fetchUserLoginRequest = () => ({
  type: FETCH_USERLOGIN_REQUEST,
});
export const fetchUserLoginSuccess = (data, dataType) => ({
  type: FETCH_USERLOGIN_SUCCESS,
  payload: { data, type: dataType },
});
export const fetchUserLoginFailure = (error) => ({
  type: FETCH_USERLOGIN_FAILURE,
  payload: error,
});
export const createUserLoginRequest = () => ({
  type: CREATE_USERLOGIN_REQUEST,
});
export const createUserLoginSuccess = (data, dataType) => ({
  type: CREATE_USERLOGIN_SUCCESS,
  payload: { data, type: dataType },
});
export const createUserLoginFailure = (error) => ({
  type: CREATE_USERLOGIN_FAILURE,
  payload: error,
});
export const updateUserLoginRequest = () => ({
  type: UPDATE_USERLOGIN_REQUEST,
});
export const updateUserLoginSuccess = (data, dataType) => ({
  type: UPDATE_USERLOGIN_SUCCESS,
  payload: { data, type: dataType },
});
export const updateUserLoginFailure = (error) => ({
  type: UPDATE_USERLOGIN_FAILURE,
  payload: error,
});
export const deleteUserLoginRequest = () => ({
  type: DELETE_USERLOGIN_REQUEST,
});
export const deleteUserLoginSuccess = (data, dataType) => ({
  type: DELETE_USERLOGIN_SUCCESS,
  payload: { data, type: dataType },
});
export const deleteUserLoginFailure = (error) => ({
  type: DELETE_USERLOGIN_FAILURE,
  payload: error,
});